import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getLocationSettings: function () {
    return axios.get(`${window.apiURL}api/user-location`)
  },
  getPlaylists: function () {
    return axios.get(`${window.apiURL}api/public/playlists`)
  },
  getPotentialArtists: function () {
    return axios.get(`${window.apiURL}api/public/potential`)
  },
  getLatestTOPReleases: function () {
    return axios.get(`${window.apiURL}api/public/latest-top-releases`)
  },
  getPublicInfo: function () {
    return axios.get(`${window.apiURL}api/public/info`)
  },
  getLatestReleases: function (params) {
    return axios.get(`${window.apiURL}api/releases`, { params })
  },
  getFeaturedReleases: function (params) {
    return axios.get(`${window.apiURL}api/featured-releases`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/services/public.js